$(function() {
  console.log("from inventory")
  var stores = [];stores.push({ code: '10101', name: 'CC Premium Plaza'});stores.push({ code: '10301', name: 'CC Santa fe'});stores.push({ code: '10401', name: 'Patio Bonito'});stores.push({ code: '10201', name: 'CC El tesoro'});$('body').on('click','#show_stock_available',function(e){
      var sku = $("#product_sku").val();
      var parts = sku.split("-");
      sku = parts[0];
      console.log('plu:', sku);
      console.log("parts", parts);
      console.log(stores);

      var settings = {
        beforeSend : function (){
          $('body').addClass("loading");
        },
        "url": "https://shopibus.gomonke.com/api/Inventory/GetInventoryCuarzo/-1/" + sku + "/-1",
        "method": "GET",
        complete: function(){
          $('body').removeClass("loading");
        }
      };
      
      $.ajax(settings).done(function (response) {
          console.log(response);

          var responseData = JSON.parse(response);

          console.log("responseData", responseData);

          var template = '<h3>Disponibilidad de inventario por tienda</h3><table><colgroup> <col span="1" style="width: 60%;"> <col span="1" style="width: 40%;"> </colgroup><thead><tr><th>Tienda</th><th>Unidades disponibles</th></thead>';

          for(var i = 0; i < responseData.length; i++){
              var warehouse = responseData[i];
              var storeName = warehouse.Warehouse;
              var storeFound =  stores.filter(function(store) {
                    return store.code == warehouse.WarehouseId;
              });
              if(storeFound && storeFound.length > 0){
                  storeName = storeFound[0].name;
              }
              template += "<tr><td>" + storeName + "</td><td style='text-align: right;'>" + warehouse.Quantity + "</td></tr>";
          }

          template += "</table>";
        
          $.magnificPopup.open({
            items:{
              src: '<div class="quick-view-popup mfp-with-anim" id="view_stock_avai">' + template + '</div>',
              type: 'inline'
            },
            removalDelay:500,
            callbacks:{
              beforeOpen: function(){
                //$('.sticky_hdr').addClass('popup');
                this.st.mainClass = 'mfp-zoom-in';
              },
              open: function(){              
                	$.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
              },
              close: function(){
                 //$('.sticky_hdr').removeClass('popup');
                $( '#view_stock_avai' ).empty();
              }
            },
        });
        
      });

      
  });
});  